import type { ProjectedGroupBonus } from '../types';
import { currentTierIndex, nextTier } from './tier-position';

export type GroupBonusStatus = {
  tone: 'success' | 'warning' | 'muted';
  text: string;
};

function needed(nextMin: number, avg: number): number {
  return Math.max(1, Math.ceil(nextMin - avg));
}

function forUnlocked(gb: ProjectedGroupBonus): GroupBonusStatus {
  const idx = currentTierIndex(gb.tiers, gb.daily_avg);
  if (idx < 0) {
    const next = nextTier(gb.tiers, gb.daily_avg);
    const min = next?.min_avg ?? 0;
    return {
      tone: 'warning',
      text: `Sube tu media a ≥${min} para entrar al bonus`,
    };
  }
  const top = gb.tiers.length - 1;
  if (idx === top)
    return {
      tone: 'success',
      text: 'Mantén tu media hasta el domingo para asegurar el tope',
    };
  const next = gb.tiers[idx + 1]!;
  const delta = needed(next.min_avg, gb.daily_avg);
  return {
    tone: 'warning',
    text: `+${delta}/día para subir a $${next.amount}`,
  };
}

// Locked path returns null — the team-goal bar above already conveys
// the gap to unlock, so a status line would just repeat the same info.
export function groupBonusStatus(
  gb: ProjectedGroupBonus
): GroupBonusStatus | null {
  if (!gb.unlocked) return null;
  return forUnlocked(gb);
}
